import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import { handleAmount, intl, recordCountlyEvent } from 'utils'
import messages from './messages'
import { Form, Input, Button, Row, Col, Divider, Checkbox, Switch, Tooltip } from 'antd'
import {
  cardNumberRule,
  expireDateRule,
  securityCodeRule,
  isAmexCardNumber,
  nameRule,
  emailRule,
  agreementRule,
} from 'utils/validateRules'
import WhiteSpace from 'components/WhiteSpace'
import LoginDrawer from 'components/LoginDrawer'
import { init } from 'routes/PayPage/Main/modules'
import { queryProtocol } from 'store/siteConfig'
import _ from 'lodash'
import WingBlank from 'components/WingBlank'
import {
  getCardBrandIconKey,
  getCardBrandIconsWithJaywanAfterVisa,
  getSupportedCardIconsFromPayMethods,
} from './cardBrandIcons'

const poweredByImage = require('../../TermsAndPrivacy/images/powered-by-botim-business.png')
const securityLogos = require('../../TermsAndPrivacy/images/security-logos-jaywan.png')

class AddNewCardiFrame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      LoginDrawerVisible: false,
      isAmex: false,
      supportedCardIcons: [],
    }

    console.log(props.siteConfig)
    if (props.siteConfig.loginType === 'customerId') {
      this.props.queryProtocol({ protocolScene: 'MCHT_USER_BIND_CARD' })
    }
  }

  componentDidMount() {
    this.setState({
      supportedCardIcons: getSupportedCardIconsFromPayMethods(this.props.payMethods)
    })
  }

  handleCardNoChange = (e) => {
    const value = e.target.value || ''
    const isAmex = isAmexCardNumber(value)

    if (isAmex !== this.state.isAmex) {
      this.setState({ isAmex }, () => {
        this.props.form.setFieldsValue({ cvv: undefined })
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(
      ['cardNo', 'expireDate', 'cvv', 'holderName', 'payerEmail', 'isSaveCard'],
      (err, values) => {
        console.log(values)
        if (!err) {
          const { pageName } = this.props
          pageName &&
            recordCountlyEvent({
              page_name: pageName,
              event_name: 'click',
              element_name: 'card_pay',
              biz_tags: {
                trade_voucher_no: sessionStorage.orderNo
              }
            })
          this.props.submit({
            ...values,
            isSaveCard: values.isSaveCard ? 'Y' : undefined,
            method: 'PAY_WITH_NEW_CARD',
            siteConfig: this.props.siteConfig,
            tabName: this.props.tabName
          })
        }
      }
    )
  }

  render() {
    const { siteConfig, form, loading, optAddCardItems = [], pageName } = this.props
    const { getFieldDecorator } = form
    const { isAmex, supportedCardIcons } = this.state
    const cardBrandIcons = getCardBrandIconsWithJaywanAfterVisa(supportedCardIcons, true)

    console.log(siteConfig)
    console.log(this.props)

    return (
      <Form className={classes.componentsPaymentMethodsAddNewCard}>
        {optAddCardItems.indexOf('login') > -1 && !siteConfig.loginToken && (
          <div className={classes.LoginButton}>
            <Button
              block
              className='font-14'
              type='primary-secondary'
              onClick={() => {
                pageName &&
                      recordCountlyEvent({
                        page_name: pageName,
                        event_name: 'click',
                        element_name: 'check',
                        biz_tags: {
                          trade_voucher_no: sessionStorage.orderNo
                        }
                      })
                this.setState({ LoginDrawerVisible: true })
              }}
            >
              {intl().formatMessage(messages.HaveSavedCardCheck)}
            </Button>
            <LoginDrawer
              title={intl().formatMessage(messages.UseMyHistory)}
              btnText={intl().formatMessage(messages.BtnText)}
              visible={this.state.LoginDrawerVisible}
              pcProps={{
                getContainer: '#rightSection',
              }}
              onChange={(LoginDrawerVisible) => {
                pageName &&
                      recordCountlyEvent({
                        page_name: pageName,
                        event_name: 'click',
                        element_name: 'close_login_popup'
                      })
                this.setState({ LoginDrawerVisible })
              }}
              type='LOGIN'
            />
            <WhiteSpace size='xl' />
            <Divider>
              <span className='text_placeholder font-12'>
                {intl().formatMessage(messages.OrOnetimePaywithCard)}
              </span>
            </Divider>
            <WhiteSpace size='xl' />
          </div>
        )}

        <Form.Item>
          {getFieldDecorator(
            'cardNo',
            cardNumberRule()
          )(
            <Input
              size='large'
              pattern='\d*'
              inputMode='numeric'
              onChange={this.handleCardNoChange}
              suffix={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  {cardBrandIcons.map((item) => (
                    <img key={getCardBrandIconKey(item)} height={18} src={item.iconUrl} alt='' />
                  ))}
                </span>
              }
              placeholder={intl().formatMessage(messages.CardNoPlaceholder)}
            />
          )}
        </Form.Item>

        <Row gutter={8}>
          <Col span={12}>
            <Form.Item>
              {getFieldDecorator(
                'expireDate',
                expireDateRule()
              )(
                <Input
                  size='large'
                  placeholder={intl().formatMessage(
                    messages.ExpireDatePlaceholder
                  )}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              {getFieldDecorator(
                'cvv',
                securityCodeRule(isAmex)
              )(
                <Input
                  type='password'
                  size='large'
                  maxLength={isAmex ? 4 : 3}
                  suffix={
                    <img height={22} src={require('./images/img2.png')} />
                  }
                  placeholder='CVV'
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          {getFieldDecorator(
            'holderName',
            nameRule()
          )(
            <Input
              size='large'
              placeholder={intl().formatMessage(
                messages.CardholderNamePlaceholder
              )}
            />
          )}
        </Form.Item>

        {optAddCardItems.indexOf('email') > -1 && (!siteConfig.loginToken || siteConfig.loginType !== 'email') && (
          <Form.Item>
            {getFieldDecorator(
              'payerEmail',
              emailRule()
            )(
              <Input
                size='large'
                suffix={
                  <Tooltip
                    arrowPointAtCenter
                    placement={siteConfig.dir === 'rtl' ? 'topLeft' : 'topRight'}
                    title={intl().formatMessage(messages.Incasethatyouwanttoreceiveyourpaymentreceipt)}
                    visible={this.state.payerEmailTooltipVisible}
                    onClick={() => this.setState({ payerEmailTooltipVisible: true })}
                    onMouseEnter={() => this.setState({ payerEmailTooltipVisible: true })}
                    onMouseLeave={() => this.setState({ payerEmailTooltipVisible: false })}
                  >
                    <span className='iconfont iconcomm-question-fill font-20 fill_icon_secondary' />
                  </Tooltip>
                }
                placeholder={intl().formatMessage(messages.EmailPlaceholder)}
              />
            )}
          </Form.Item>
        )}

        {optAddCardItems.indexOf('saveCard') > -1 && siteConfig.loginToken && (
          <>
            <Row style={{ marginTop: -6 }}>
              <Col span={12}>{intl().formatMessage(messages.Savefornexttimeuse)}</Col>
              <Col span={12}>
                <div className='text-right'>
                  {getFieldDecorator('isSaveCard', {
                    initialValue: true,
                    valuePropName: 'checked'
                  })(<Switch />)}
                </div>
              </Col>
            </Row>
            {siteConfig.loginType === 'email' && siteConfig.email && (
              <>
                <WhiteSpace size='md' />
                <WingBlank className='fill_special text_secondary font-12'>
                  <WhiteSpace />
                  {form.getFieldValue('isSaveCard')
                    ? `${intl().formatMessage(messages.SavedwithEmail)} ${siteConfig.email}`
                    : intl().formatMessage(messages.PayBypaymentprovidesservicetothousandsmerchants)}
                  <WhiteSpace />
                </WingBlank>
              </>
            )}
            {siteConfig.loginType === 'customerId' && (
              <>
                <WhiteSpace size='md' />
                <WingBlank className='fill_special text_secondary font-12'>
                  <WhiteSpace />
                  {intl().formatMessage(messages.Savedwithyourorderaccountid)}
                  <WhiteSpace />
                </WingBlank>
              </>
            )}
            <WhiteSpace size='md' />
          </>
        )}

        {optAddCardItems.indexOf('agreements') > -1 && siteConfig.loginToken && siteConfig.loginType === 'customerId' && siteConfig.agreementTips && (
          <Form.Item className={`${classes.checkbox} text-left`}>
            {form.getFieldDecorator(
              'agreements',
              agreementRule()
            )(
              <Checkbox>
                <span
                  className='font-12'
                  dangerouslySetInnerHTML={{
                    __html: siteConfig.agreementTips,
                  }}
                />
              </Checkbox>
            )}
          </Form.Item>
        )}

        <Form.Item>
          <Button
            loading={loading}
            block
            size='large'
            type='primary'
            onClick={this.handleSubmit}
          >
            {intl().formatMessage(messages.Pay)} {_.get(siteConfig, 'payInfo.payAmount') && handleAmount(siteConfig.payInfo.payAmount)}
          </Button>
        </Form.Item>

        {optAddCardItems.indexOf('PCI') > -1 && (
          <div className={classes.iframeFooterLogos}>
            <div className={classes.iframePoweredBy}>
              <img height={16} src={poweredByImage} alt='' />
            </div>
            <div className={classes.iframeSecurityLogos}>
              <img height={20} src={securityLogos} alt='' />
            </div>
            <div className='font-12 text_placeholder text-center' style={{ lineHeight: 1.2 }}>
              {intl().formatMessage(messages.PCI)}
            </div>
          </div>
        )}
      </Form>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {
    init,
    queryProtocol,
  }
)(Form.create()(AddNewCardiFrame))
